import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { ApiRequestService } from 'idt-ecommerce-api/_api/api-util/api-request.service';

import { ApiPromotions } from './models/api-promotion.models';


export interface ApiPromotionServiceInterface {
    getPromotions(
    storeId: string,
    languageId: string,
  ): Observable<ApiPromotions>;
}

@Injectable()
export class ApiPromotionService implements ApiPromotionServiceInterface {

  constructor(
    private readonly http: HttpClient,
    private readonly requestService: ApiRequestService
  ) {}

  public getPromotions(storeId: string, languageId: string): Observable<ApiPromotions> {
    const slug = `/support/store/${storeId}/promotion`;
    const options = {
      withCredentials: true
    };

    return this.requestService.requestUrl(slug, languageId).pipe(
      switchMap((url: string) => this.http.get<ApiPromotions>(url, options))
    );
  }

}
